/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import ExperienceFormWrapper from "./ExperienceFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as controlPanelActions from "../../../actions/controlPanelActions";
import * as ExperiencesActions from "../../../actions/experiencesActions";
import * as lookupsActions from "../../../actions/lookupsActions";
import * as validationActions from "../../../actions/validationActions";

class ExperiencesPage extends Component {
	constructor(props) {
		super(props);
		this.appId = "";
		this.appKey = this.props.match.params.appKey;
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			this.appId = app ? app.id : "";
		}
		this.state = {
			hasFormApi: false,
			formApi: null,
		};
	}

	getAppId = () => {
		let appId = "";
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			appId = app ? app.id : "";
		}
		return appId;
	};

	componentDidMount() {
		this.props.actions.loadExperiences(this.appKey);
		this.props.lookupsActions.getCultures();
	}

	reloadExperiences = () => {
		const { actions, history } = this.props;
		actions.loadExperiences(this.appKey);
		history.push(`/apps/${this.appKey}/experiences`);
	};

	loadExperience = expKey => {
		const { actions } = this.props;
		actions.loadExperience(expKey);
	};

	logError = error => {
		if (error.response.data.Errors) {
			error.response.data.Errors.forEach(error => {
				this.state.formApi.setError(error.Key, error.Value);
			});
		} else if (error.response.data.Message) {
			this.props.controlPanelActions.displayError(error.response.data.Message);
		}
	};

	getFormApi = formApi => {
		this.setState({ formApi, hasApi: true });
	};

	createItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const appId = this.getAppId();
		const data = {
			...values,
			appId: appId,
		};
		globalActions.createItem(data, "/experiences", this.reloadExperiences, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		const { globalActions } = this.props;
		globalActions.updateItem(
			values,
			`/experiences/${itemId}`,
			this.reloadExperiences,
			this.logError,
			submitHandler
		);
	};

	copyItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const appId = this.getAppId();
		const data = {
			...values,
			appId: appId,
		};
		globalActions.createItem(data, "/experiences", this.reloadExperiences, this.logError, submitHandler);
	};

	deleteItem = (id, name) => {
		let appKey = this.appKey;
		const { actions, globalActions } = this.props;
		const onSuccess = () => {
			actions.loadExperiences(appKey);
		};
		globalActions.deleteItem(`/experiences/${id}`, onSuccess, this.logError, name);
	};

	renderGrid = () => {
		const { experiences } = this.props.experiences;
		const { cultures } = this.props;

		return (
			<div>
				{experiences && cultures ? (
					<Grid
						defaultText="Create your first experience..."
						columnNames={["Name"]}
						objectKey="Experiences"
						singleItemName="Experience"
						pluralItemName="Experiences"
						items={experiences}
						data={this.props}
						delete={this.deleteItem}
					/>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { experiences, cultures } = this.props;
		return (
			<Page title="Experiences">
				{experiences && cultures ? (
					<GridFormSwitcher
						objectKey="Experiences"
						singleItemName="Experience"
						pluralItemName="Experiences"
						RenderCopy={ExperienceFormWrapper}
						RenderEdit={ExperienceFormWrapper}
						RenderNew={ExperienceFormWrapper}
						items={experiences.experiences}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						cultures={cultures}
						getSingleItem={this.loadExperience}
						getFormApi={this.getFormApi}
						hasFormApi={this.state.hasFormApi}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

ExperiencesPage.propTypes = {
	match: PropTypes.any,
	experiences: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	history: PropTypes.object,
	apps: PropTypes.array,
	cultures: PropTypes.array,
	lookupsActions: PropTypes.object,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	experiences: state.experiences,
	apps: state.apps.apps,
	cultures: state.cultures.cultures,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(ExperiencesActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	lookupsActions: bindActionCreators(lookupsActions, dispatch),
	validationActions: bindActionCreators(validationActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ExperiencesPage);
